<template>
  <el-form
    ref="form"
    :model="formValue"
    :always-display-error="false"
  >
    <el-row :gutter="24">
      <el-col
        :span="12"
      >
        <div>{{ $t('consumer-profile.email-notifications.language') }}</div>
      </el-col>
      <el-col
        :span="10"
      >
        <el-form-item
          prop="language"
          :display-error-always="false"
        >
          <el-select
            v-model="formValue.language"
            filterable
          >
            <el-option
              v-for="language in languages"
              :key="language.code"
              :value="language.code"
              :label="language.label"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col
        :span="12"
      >
        <div>{{ $t('consumer-profile.email-notifications.support') }}</div>
      </el-col>
      <el-col :span="12">
        <el-form-item
          prop="support"
          :display-error-always="false"
        >
          <el-checkbox
            v-model="formValue.support"
            :label="$t('consumer-profile.email-notifications.ticket-status')"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col
        :span="12"
      >
        <div>{{ $t('consumer-profile.email-notifications.marketing') }}</div>
      </el-col>
      <el-col :span="12">
        <el-form-item
          prop="home"
          :display-error-always="false"
        >
          <el-checkbox
            v-model="formValue.home"
            :label="$t('consumer-profile.email-notifications.home-offers')"
          />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { EMAIL_NOTIFICATIONS_LANGUAGES } from '@/app/library/languageSelector';

export default {
  name: 'EmailNotificationsSettingsForm',
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  emits: [
    'input'
  ],
  data() {
    return {
      formValue: this.convertFormValueToProxy(this.getDefaultFormValue()),
      languages: EMAIL_NOTIFICATIONS_LANGUAGES
    };
  },
  created() {
    this.setFormValue(this.value);
  },
  async mounted() {
    await this.$nextTick();
    this.$refs.form.clearValidate();
  },
  methods: {
    convertFormValueToProxy(formValue) {
      const self = this;

      return new Proxy(formValue, {
        get(target, prop) {
          return target[prop];
        },
        set(target, prop, value) {
          target[prop] = value;
          self.$emit('input', target);

          return true;
        }
      });
    },
    getDefaultFormValue() {
      return {
        language: undefined,
        support: undefined,
        home: undefined
      };
    },
    setFormValue(value) {
      Object.keys(value).forEach((key) => {
          this.formValue[key] = value[key];
      });
    },
    clearValidate() {
      this.$refs.form.clearValidate();
    },
    async validate() {
      try {
        return await this.$refs.form.validate();
      } catch (e) {
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  @import '@uikit/ui-kit/themes/acronis/src/common/variables';

  .el-row {
    display: flex;
    align-items: center;
    padding: 0 24px;
    border-bottom: $av-border-sm $av-brand-accent;

    &:last-child {
      margin-bottom: 16px;
    }

    .el-form-item {
      padding-top: 8px;
    }
  }
</style>
